import { useState, useEffect } from 'react';
import { Star, CaretDownFill, CheckCircleFill, InfoCircle } from 'react-bootstrap-icons';
import { Slider, Select } from 'antd';
import Data from '../../data/Data';
import Header from '../Header';
import { useAuth } from '../../contexts/AuthContext';
import DesignerDetails from './DesignerDetails';
import Cookies from 'js-cookie';

function Designers() {
    const { isLoggedIn } = useAuth();
    const [fetchedDesigners, setFetchedDesigners] = useState([]);
    const [designers, setDesigners] = useState([]);

    const [countries, setCountries] = useState([]);
    const [timeZones, setTimeZones] = useState([]);

    const [rankingRange, setRankingRange] = useState([1, 5]);
    const [timeFilter, setTimeFilter] = useState(0);
    const [countryFilter, setCountryFilter] = useState(undefined);
    const [timeZoneFilter, setTimeZoneFilter] = useState(undefined);

    const [showFilter, setShowFilter] = useState(false);

    const [designer, setDesigner] = useState(undefined);
    const [loadedReferences, setLoadedReferences] = useState([]);
    const [selectedDesigners, setSelectedDesigners] = useState([]);

    const timeFilterOptions = [];
    for (let i = 0.5; i < 3; i += 0.5) {
        timeFilterOptions.push(i + ' h');
    }
    for (let i = 3; i < 24; i++) {
        timeFilterOptions.push(i + ' h');
    }
    for (let i = 1; i < 10; i++) {
        timeFilterOptions.push(i + ' d');
    }
    timeFilterOptions.push('10+ d');

    const fetchDesigners = async () => {
        const res = await Data.fetchDesigners();
        setFetchedDesigners(res);
        setDesigners(res);
    }

    const fetchCountries = async () => {
        const res = await Data.fetchCountries();
        setCountries(res.map(country => ({ 'label': country.name.common, 'value': country.cca2.toLowerCase() })));
    }

    function filterDesigners() {
        if (fetchedDesigners.length !== 0) {
            setDesigners(
                fetchedDesigners.filter(designer =>
                    designer.ranking !== null ? designer.ranking > rankingRange[0] && designer.ranking < rankingRange[1] : true &&
                        // (designer.timeRange !== undefined && designer.timeRange !== null) ? designer.timeRange > timeRange[0] && designer.time < timeRange[1] : true &&
                        countryFilter !== undefined ? countryFilter.includes(designer.country.toLowerCase()) : true &&
                            timeZoneFilter !== undefined ? timeZoneFilter.map(timeZone => timeZone.split('-'[1])).includes(designer.timeZone) : true
                )
            );
        }
    }

    const getDesignerDetails = async (designer, e) => {
        e.stopPropagation();
        setDesigner(designer);
    };

    const addPropertyToProject = (key, value) => {
        const project = JSON.parse(localStorage.getItem('project'));
        if (project[key].includes(JSON.stringify(value))) {
            project[key] = project[key].filter(item => item !== JSON.stringify(value));
        }
        else {
            project[key].push(JSON.stringify(value));
        }
        localStorage.setItem('project', JSON.stringify(project));
    }

    const handleSelectDesigner = async (newDesigner, e) => {
        e.stopPropagation();
        setSelectedDesigners(prevState => {
            if (prevState.includes(newDesigner.id)) {
                return prevState.filter(designerId => designerId !== newDesigner.id);
            } else {
                return [...prevState, newDesigner.id];
            }
        });
        addPropertyToProject('designers', newDesigner);
    };

    useEffect(() => {
        if (!isLoggedIn)
            window.location = '/login';

        if (localStorage.getItem('project') === null)
            window.location = '/dashboard';

        let project = JSON.parse(localStorage.getItem('project'));
        project.designers = project.designers.length === 0 ? [] : project.designers;
        localStorage.setItem('project', JSON.stringify(project));

        fetchDesigners();
        fetchCountries();
        setTimeZones(Data.fetchTimeZones().map(timeZone => ({ 'label': timeZone.timeZone + '(' + timeZone.offset + ')', 'value': timeZone.timeZone + timeZone.offset })));

        if (project.designers.length !== 0) {
            setSelectedDesigners(project.designers.map(designer => JSON.parse(designer).id));
        }

        return () => {
            Cookies.remove('loadedReferences');
        };
    }, [isLoggedIn]);

    const filters = () => (
        <div className='p-4 filters'>
            <h2>Filter</h2>
            <div className='py-3'>
                <p>Ranking</p>
                <Slider
                    range
                    min={1}
                    max={5}
                    step={0.1}
                    value={rankingRange}
                    onChange={(value) => { setRankingRange(value); filterDesigners() }}
                />
                <div className='row'>
                    <div className='col-6'>1</div>
                    <div className='col-6 text-end'>5</div>
                </div>
            </div>

            <div className='py-3'>
                <p>Time (weeks)</p>
                <Slider
                    min={0}
                    max={timeFilterOptions.length - 1}
                    step={1}
                    value={timeFilter}
                    onChange={(value) => { setTimeFilter(value); filterDesigners() }}
                    tooltip={{ formatter: (value) => timeFilterOptions[value] }}
                />
                <div className='row'>
                    <div className='col-6'>1 h</div>
                    <div className='col-6 text-end'>10+ d</div>
                </div>
            </div>

            <div className='py-3'>
                <p>Country</p>
                <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="All"
                    onChange={(value) => { setCountryFilter(value.length === 0 ? undefined : value); filterDesigners() }}
                    options={countries}
                />
            </div>

            <div className='py-3'>
                <p>Timezone</p>
                <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="All"
                    onChange={(value) => { setTimeZoneFilter(value.length === 0 ? undefined : value); filterDesigners() }}
                    options={timeZones}
                />
            </div>

            <div className='text-end d-lg-none'>
                <button className='btn btn-primary btn-sm mt-3' onClick={() => setShowFilter(false)}>Search</button>
            </div>
        </div>
    );

    return (
        <div className='Designers'>
            <Header background authButton sticky />
            <div className="row">
                <h1 className='ms-5 mt-3 mb-4'>Designers</h1>
                <div className="d-none d-lg-block col-lg-3">
                    {filters()}
                </div>
                <div className="d-lg-none px-5">
                    <button className='btn-filter-collapse' onClick={() => setShowFilter(!showFilter)}>Filters <CaretDownFill /></button>
                    {showFilter && filters()}
                </div>
                <div className="col-lg-9">
                    <div className='row demo-profiles mb-5'>
                        {
                            designers.length > 0 && designers.map((designer) => (
                                <div className='col-6 col-md-4 col-xl-3 d-flex justify-content-center my-3' key={designer.id}>
                                    <div className={`${selectedDesigners.includes(designer.id) ? 'designer-page-selected' : 'designer-page'} pt-4 pb-3 px-5 position-relative`} onClick={(e) => handleSelectDesigner(designer, e)}>
                                        <div className='profile'>
                                            <img src={`https://hatscripts.github.io/circle-flags/flags/${designer.country.toLowerCase()}.svg`} className='flag' alt={designer.cca2} />
                                            <img src={designer.avatar} alt='profile' className='img-fluid' />
                                        </div>
                                        {selectedDesigners.includes(designer.id) && <CheckCircleFill className='position-absolute top-0 end-0 m-3 designer-page-check' style={{ transform: "scale(1.5)", color: 'rgb(0, 110, 244)' }} />}
                                        <p className='text-center pt-4'>{designer.firstName} {designer.lastName}</p>
                                        <p className='text-secondary d-flex align-items-center justify-content-center'>{designer.ranking} <Star className='mx-1' /> {designer.country}</p>
                                        <InfoCircle className='position-absolute bottom-0 start-0 m-3 designer-page-info designer-info-hover' onClick={(e) => { getDesignerDetails(designer, e) }} />
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            {designer !== undefined && <DesignerDetails designer={designer} setDesigner={setDesigner} loadedReferences={loadedReferences} setLoadedReferences={setLoadedReferences} />}
            <div style={{
                position: 'fixed',
                left: 0,
                bottom: 0,
                width: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '10px 0',
            }}>
                <button className='btn btn-primary' onClick={() => window.location = '/project-details'}>Select designer(s)</button>
            </div>
        </div>
    )
}

export default Designers;